import clienteAxios from "../config/axios";

export async function getAllCategoriasRRHH() {
    return clienteAxios.get(`/categoriasRRHH`);
}

export async function getCategoriasRRHHFromSoftland() {
    return clienteAxios.get(`/categoriasRRHH/actualizarCategoriasRRHH`);
}

export async function addCategoriasRRHH(categoriasRRHH) {
    return clienteAxios.post(`/categoriasRRHH`,{categoriasRRHH:categoriasRRHH});
}

export async function updateCategoriasRRHH(id,updates) {
    return clienteAxios.put(`/categoriasRRHH/${id}`,{updates});
}

export async function deleteCategoriasRRHH(id) {
    return clienteAxios.delete(`/categoriasRRHH/${id}`,id);
}